import React, { useState } from 'react';
import { getAccountDetails, getOrderDetails, saveLookUpCSOData } from '../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { browserHistory } from 'react-router';

const LookUpCSO = props => {
	const { user, order } = useSelector(({ user, order }) => ({ user, order }));
	const [searchForm, setSearchForm] = useState(() =>
		order.lookUpCSOData
			? order.lookUpCSOData.searchForm
			: {
					fields: {
						orderNumber: ''
					},
					errors: {
						orderNumber: false
					}
			  }
	);
	const [orderDetails, setOrderDetails] = useState(() => (order.lookUpCSOData ? order.lookUpCSOData.orderDetails : undefined));
	const dispatch = useDispatch();

	const isFieldValid = (fieldName, fieldValue) => {
		if (fieldName === 'orderNumber') {
			return /^[\d]{10}$/.test(fieldValue);
		}
	};

	const handleSearchFormChange = e => {
		const { name: fieldName, value: fieldValue } = e.target;

		setSearchForm(searchForm => ({
			fields: {
				...searchForm.fields,
				[fieldName]: fieldValue
			},
			errors: {
				...searchForm.errors,
				[fieldName]: searchForm.errors[fieldName] ? (isFieldValid(fieldName, fieldValue) ? false : true) : false
			}
		}));
	};

	const handleSearch = e => {
		e.preventDefault();
		for (const fieldName in searchForm.fields) {
			if (!isFieldValid(fieldName, searchForm.fields[fieldName])) {
				setSearchForm(searchForm => ({
					...searchForm,
					errors: {
						...searchForm.errors,
						[fieldName]: true
					}
				}));
				return;
			}
		}

		dispatch(
			getOrderDetails(`requestType=getOrderDetails&orderNumber=${searchForm.fields.orderNumber}`, orderDetailsResponse => {
				if (orderDetailsResponse.responseObject && orderDetailsResponse.responseObject.accountNumber) {
					if (
						(user.userDetails.typeOfUser !== 'employee' || user.userDetails.isNonGEASsoUser) &&
						!(
							user.approvedAccounts &&
							user.approvedAccounts.responseObject &&
							user.approvedAccounts.responseObject.length &&
							user.approvedAccounts.responseObject.some(approvedAccount => approvedAccount.ACCOUNTNUMBER === orderDetailsResponse.responseObject.accountNumber)
						)
					) {
						setOrderDetails(null);
					} else {
						dispatch(
							getAccountDetails(
								`accountNumber=${orderDetailsResponse.responseObject.accountNumber}&requestType=getAccountDetails&ssoId=${user.userDetails.sso}`,
								true,
								accountDetailsResponse => {
									if (!(accountDetailsResponse.status && accountDetailsResponse.responseObject && accountDetailsResponse.responseObject.length)) {
										setOrderDetails(null);
									} else {
										setOrderDetails({
											...orderDetailsResponse.responseObject,
											accountDescription: accountDetailsResponse.responseObject[0].ACCOUNTDESCRIPTION
										});
									}
								}
							)
						);
					}
				} else {
					setOrderDetails(null);
				}
			})
		);
	};

	const handleOrderDetailsNavigation = e => {
		e.preventDefault();
		const { selectedAccountsAllPriceSources } = user;
		const priceSources = selectedAccountsAllPriceSources.responseObject || [];

		dispatch(
			saveLookUpCSOData({
				searchForm,
				orderDetails
			})
		);

		if (['NCRP', 'Stock Displays'].includes(orderDetails.orderSource)) {
			dispatch(
				getOrderDetails(
					`requestType=getOrderDetails&P_ORDER_NUMBER=${searchForm.fields.orderNumber}`,
					orderDetailsResponse => {
						if (orderDetailsResponse.responseObject) {
							browserHistory.push('/orderDetails');
						}
					},
					true,
					true
				)
			);
		} else {
			browserHistory.push('/orderDetails');
		}
	};

	const handleAccountNavigation = e => {
		e.preventDefault();
		props.handleAccountAndPriceSourceDialog({ accountNumber: orderDetails.accountNumber, show: true });
	};

	return (
		<div>
			<h1 className="pageTitle" style={{ margin: '21px 0' }}>
				Look Up CSO
			</h1>
			<p>
				This search will find a <strong>CSO</strong> for <strong>ANY</strong> account that you have access to
			</p>
			<form className="d-flex align-items-end align-items-sm-stretch push" onSubmit={handleSearch}>
				<div className={`d-inline-flex flex-column flex-sm-row align-items-sm-center my-0${searchForm.errors.orderNumber ? ' error' : ''}`}>
					<label htmlFor="orderNumber">
						<b>CSO (Order number):</b>
					</label>
					<span className="me-2 mx-sm-2">
						<input
							type="text"
							id="orderNumber"
							name="orderNumber"
							className={`d-block${searchForm.errors.orderNumber ? ' error' : ''}`}
							value={searchForm.fields.orderNumber}
							onChange={handleSearchFormChange}
						/>
						{searchForm.errors.orderNumber && <p className="position-absolute message">CSO’s must have 10 digits</p>}
					</span>
				</div>
				<button className="blueButton">Search</button>
			</form>
			{orderDetails === null && <p className="text-center">No Orders found.</p>}
			{orderDetails && (
				<div>
					<hr />
					<div className="d-block d-sm-none p-2 border rounded">
						<dl className="d-flex justify-content-between border-bottom">
							<dt>CSO</dt>
							<dd>
								{orderDetails.accountNumber === user.selectedAccount.ACCOUNTNUMBER && orderDetails.orderType === 'Standard Sales' ? (
									<a href="" onClick={handleOrderDetailsNavigation}>
										{orderDetails.orderNumber}
									</a>
								) : (
									orderDetails.orderNumber
								)}
							</dd>
						</dl>
						<dl className="d-flex justify-content-between border-bottom">
							<dt>Order Type</dt>
							<dd>{orderDetails.orderType}</dd>
						</dl>
						<dl className="d-flex justify-content-between border-bottom">
							<dt>Account #</dt>
							<dd>
								{user.selectedAccount.ACCOUNTNUMBER !== orderDetails.accountNumber ? (
									<a href="" onClick={handleAccountNavigation}>
										{orderDetails.accountNumber}
									</a>
								) : (
									orderDetails.accountNumber
								)}
							</dd>
						</dl>
						<dl className="d-flex justify-content-between border-bottom">
							<dt>Account Description</dt>
							<dd>{orderDetails.accountDescription}</dd>
						</dl>
						<dl className="d-flex justify-content-between border-bottom">
							<dt>Order Date</dt>
							<dd>{orderDetails.orderDate && moment(orderDetails.orderDate).format('MM/DD/YYYY')}</dd>
						</dl>
						<dl className="d-flex justify-content-between border-bottom">
							<dt>Status</dt>
							<dd>{orderDetails.orderStatus}</dd>
						</dl>
						<dl className="d-flex justify-content-between border-bottom">
							<dt>PO</dt>
							<dd>{orderDetails.poNumber}</dd>
						</dl>
					</div>
					<table className="d-none d-sm-table dataTable fullWidth">
						<thead>
							<tr>
								<th>CSO</th>
								<th>Order Type</th>
								<th>Account #</th>
								<th>Account Description</th>
								<th>Order Date</th>
								<th>Status</th>
								<th>PO</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									{orderDetails.accountNumber === user.selectedAccount.ACCOUNTNUMBER && orderDetails.orderType === 'Standard Sales' ? (
										<a href="" onClick={handleOrderDetailsNavigation}>
											{orderDetails.orderNumber}
										</a>
									) : (
										orderDetails.orderNumber
									)}
								</td>
								<td>{orderDetails.orderType}</td>
								<td>
									{user.selectedAccount.ACCOUNTNUMBER !== orderDetails.accountNumber ? (
										<a href="" onClick={handleAccountNavigation}>
											{orderDetails.accountNumber}
										</a>
									) : (
										orderDetails.accountNumber
									)}
								</td>
								<td>{orderDetails.accountDescription}</td>
								<td>{orderDetails.orderDate && moment(orderDetails.orderDate).format('MM/DD/YYYY')}</td>
								<td>{orderDetails.orderStatus}</td>
								<td>{orderDetails.poNumber}</td>
							</tr>
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};

export default LookUpCSO;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/LookUpCSO/index.jsx